// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.4
//   protoc               unknown
// source: qonto/kycb/api/kyc_verification/firstparty/v3/send_membership_kyc_sms.proto

/* oxlint-disable */

/** Request to send a KYC verification SMS for the authenticated membership. */
export interface ApiSendMembershipKycSmsRequest {
  /** Name of SMS template identifying the KYC provider content. */
  readonly templateName: string;
}

/** Response returned after sending a membership KYC verification SMS. */
export interface ApiSendMembershipKycSmsResponse {
  /** Name of SMS template used for the verification message. */
  readonly templateName: string;
}

export const ApiSendMembershipKycSmsRequest: MessageFns<ApiSendMembershipKycSmsRequest> = {
  fromJSON(object: any): ApiSendMembershipKycSmsRequest {
    return { templateName: isSet(object.template_name) ? globalThis.String(object.template_name) : "" };
  },

  toJSON(message: ApiSendMembershipKycSmsRequest): unknown {
    const obj: any = {};
    if (message.templateName !== undefined && message.templateName !== null) {
      obj.template_name = message.templateName;
    }
    return obj;
  },
};

export const ApiSendMembershipKycSmsResponse: MessageFns<ApiSendMembershipKycSmsResponse> = {
  fromJSON(object: any): ApiSendMembershipKycSmsResponse {
    return { templateName: isSet(object.template_name) ? globalThis.String(object.template_name) : "" };
  },

  toJSON(message: ApiSendMembershipKycSmsResponse): unknown {
    const obj: any = {};
    if (message.templateName !== undefined && message.templateName !== null) {
      obj.template_name = message.templateName;
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
